import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BOARDING_PASS_ISSUE_HPBP_STORE_NAME, BoardingPassIssueHpbpState } from './boarding-pass-issue-hpbp.state';

/** Select BoardingPassIssueHpbp State */
export const selectBoardingPassIssueHpbpState = createFeatureSelector<BoardingPassIssueHpbpState>(
  BOARDING_PASS_ISSUE_HPBP_STORE_NAME
);

/** Select BoardingPassIssueHpbp isPending status */
export const selectBoardingPassIssueHpbpIsPendingStatus = createSelector(
  selectBoardingPassIssueHpbpState,
  (state) => !!state.isPending
);

/** Select BoardingPassIssueHpbp isFailure status */
export const selectBoardingPassIssueHpbpIsFailureStatus = createSelector(
  selectBoardingPassIssueHpbpState,
  (state) => !!state.isFailure
);
